interface SegmentsPieChartTooltipProps {
  currency?: string;
  segment: string;
  percentage: number;
  financialValue?: number;
}
export default function SegmentsPieChartTooltip({
  currency,
  segment,
  percentage,
  financialValue,
}: SegmentsPieChartTooltipProps) {
  const percentageFormatter = new Intl.NumberFormat("en-US", {
    style: "percent",
    maximumFractionDigits: 1,
  });

  const moneyFormatter = new Intl.NumberFormat("en-US", {
    style: currency ? "currency" : "unit",
    notation: "compact",
    compactDisplay: "short",
    currency,

    minimumSignificantDigits: 1,
    maximumSignificantDigits: financialValue && financialValue > 1e6 ? 2 : 4,
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  });

  return (
    <div className="z-10 flex flex-col space-y-3 p-2 text-[13px] text-sm">
      <div className="grid auto-cols-auto grid-flow-col justify-between gap-x-4">
        <span className="font-mono font-semibold text-slate-600 dark:text-slate-300">{segment}</span>
        <strong className="font-mono text-slate-700 dark:text-slate-200">
          {percentageFormatter.format(percentage / 100)}
        </strong>
        {financialValue && (
          <strong className="font-mono text-emerald-700 dark:text-emerald-400">
            {moneyFormatter.format(financialValue)}
          </strong>
        )}
      </div>
    </div>
  );
}
